import React from 'react';

import { defineMessages, FormattedMessage } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import { VerifiedTeamIcon } from '@atlaskit/people-teams-ui-public/verified-team-icon';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
import { components, type OptionProps } from '@atlaskit/select';

const messages = defineMessages({
	teamTypeDefault: {
		id: 'people-teams.team-type-select.team-type-default',
		defaultMessage: 'Default type',
		description: 'Text for the default team type',
	},
});

export type TeamTypeData = {
	name: string;
	verified: boolean;
	default: boolean;
	description: string;
};

export type TeamTypeOptionData = {
	label: string;
	value: string;
	data?: TeamTypeData;
};

type TeamTypeOptionProps = OptionProps<TeamTypeOptionData, false>;

const styles = cssMap({
	optionWrapper: {
		width: '100%',
		cursor: 'pointer',
	},
	textWrapper: {
		minWidth: 'max-content',
	},
});

export const TeamTypeOption = (props: TeamTypeOptionProps): React.JSX.Element => {
	const { data } = props;
	const teamTypeData = data.data;

	return (
		<components.Option {...props}>
			<Box xcss={styles.optionWrapper}>
				<Stack space="space.025">
					<Inline space="space.050" alignBlock="center">
						<Box>
							<Text maxLines={1} color="color.text">
								{teamTypeData?.name}
							</Text>
						</Box>
						{teamTypeData?.verified && <VerifiedTeamIcon size="small" spacing="none" />}
					</Inline>
					<Inline space="space.025">
						{teamTypeData?.default && (
							<>
								<Box xcss={styles.textWrapper}>
									<Text color="color.text.subtlest" size="small" maxLines={1}>
										<FormattedMessage {...messages.teamTypeDefault} />
									</Text>
								</Box>
								<Text size="small" color="color.text.subtlest">
									•
								</Text>
							</>
						)}
						<Text size="small" color="color.text.subtlest" maxLines={1}>
							{teamTypeData?.description}
						</Text>
					</Inline>
				</Stack>
			</Box>
		</components.Option>
	);
};
